export const LANGUAGE_KEY = "lang";

export enum ELanguages {
  English = "en",
  Vietnamese = "vi",
}
